// Pure selection helpers for the map view.

// The map popup shows (in priority order) the anomaly popup, then the line
// popup, then the XYZ row popup. Selecting an XYZ point therefore has to clear
// the other two selections or the old line/anomaly popup would stay on top (M14).
export function xyzPointSelection({ longitude, latitude, properties, zFields }) {
  return {
    selectedFeature: null,
    selectedAnomaly: null,
    xyzPopup: { longitude, latitude, properties, zFields },
  };
}
